import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InspectionTab from "./Addnewaction";
import Colors from "./../../Global/colors"
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import GlobalApi from "./../../Global";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});



export default function InspectionModal({ onClose, data1, isModalOpen,currentEditRow }) {
  const {t} = useTranslation();
  let company = useSelector((state) => state.companyReducer.company);
  const [open] = React.useState(true);
  const [inspectionShares, setInspectionShares] = React.useState([])
  const [users, setUsers] = React.useState([]);
  const handleClose = () => {
    // setOpen(false);
    onClose();
  };

  React.useEffect(() => {
    getInspectionShare()
    getUsers()
  }, [])

  const getInspectionShare = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      inspection_id: isModalOpen.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/InspectionShare/get_all_inspection_shares?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log(response)
          if (response.data) {
            setInspectionShares(response.data);
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            // console.log("opopopop");
            getInspectionShare();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };
  const getUsers = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log(response)
          if (response.data) {
            setUsers(response.data);
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            // console.log("opopopop");
            getInspectionShare();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };


  let data = isModalOpen
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        >
        <DialogTitle
          id="customized-dialog-title"
          style={{ background: Colors.globalColor9 }}
          // onClose={handleClose}
        >
          {data?.schedule_title}
        </DialogTitle>
        <DialogContent style={{padding:'0px 20px 0px', backgroundColor:Colors.globalColor9}}>
        <Paper square variant={"outlined"}>
        <InspectionTab data={data} InspectionShares={inspectionShares} users={users} currentEditRow={currentEditRow}/>
      </Paper>
        </DialogContent>
        <DialogActions style={{backgroundColor:Colors.globalColor9}}>
          <Button variant="contained" type="submit" className="addBtn" component="span" style={{ backgroundColor: Colors.globalColor8 }} onClick={handleClose}>
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}



